"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportFeedbackOutput = instanceOfReportFeedbackOutput;
exports.ReportFeedbackOutputFromJSON = ReportFeedbackOutputFromJSON;
exports.ReportFeedbackOutputFromJSONTyped = ReportFeedbackOutputFromJSONTyped;
exports.ReportFeedbackOutputToJSON = ReportFeedbackOutputToJSON;
var Metadata_1 = require("./Metadata");
var ReportFeedback_1 = require("./ReportFeedback");
/**
 * Check if a given object implements the ReportFeedbackOutput interface.
 */
function instanceOfReportFeedbackOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ReportFeedbackOutputFromJSON(json) {
    return ReportFeedbackOutputFromJSONTyped(json, false);
}
function ReportFeedbackOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ReportFeedback_1.ReportFeedbackFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ReportFeedbackOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ReportFeedback_1.ReportFeedbackToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
